import { Box, Text, Button } from "rebass/styled-components";
import theme from "../../lib/theme";
import Heading from "./Heading";

interface HeadlineProps {
  variant: string;
  title: string;
  subtitle?: string;
  textAlign?: any;
  buttonTitle?: any;
  onSubmit?: () => void;
}

function Headline(props: HeadlineProps) {
  const {
    variant,
    title,
    subtitle,
    buttonTitle,
    onSubmit,
    textAlign = false
  } = props;

  return (
    <Box variant={`headline.box.${variant}`} sx={{ textAlign: textAlign }}>
      <Heading as="h2" variant="headline.title">
        {title}
      </Heading>
      {subtitle && (
        <Text as="h3" variant="headline.subtitle">
          {subtitle}
        </Text>
      )}
      {buttonTitle && (
        <Box variant={"headline.boxButton"}>
          <Button sx={theme.headline.button} onClick={onSubmit}>
            {buttonTitle}
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default Headline;
